import useAppContext from "@/src/components/appContext/useAppContext";
import { FeatureToggle } from "@/src/constants/featureFlags";

export function useFeatureFlag() {
  const { ctx } = useAppContext();

  const isEnabled = (key: FeatureToggle) =>
    ctx?.featureFlags ? ctx.featureFlags[key] : false;

  return {
    isApiDebugEnabled: isEnabled(FeatureToggle.EnableApiDebug),
    isUIDebugEnabled: isEnabled(FeatureToggle.EnableUiDebug),
    isActivityHistoryEnabled: isEnabled(FeatureToggle.ActivityHistory),
    isFactualCreativeEnrichmentEnabled: isEnabled(
      FeatureToggle.FactualCreativeEnrichment
    ),
    isEnrichmentFlowConfigurationEnabled: isEnabled(
      FeatureToggle.EnrichmentFlowConfiguration
    ),
    isBulkImportEmptyValueEnabled: isEnabled(
      FeatureToggle.BulkImportEmptyValue
    ),
    isAiEnrichmentReviewEnabled: isEnabled(FeatureToggle.AiEnrichmentReview),
    isImportAttributeOptionsSmartImportEnabled: isEnabled(
      FeatureToggle.ImportAttributeOptionsSmartImport
    ),
    isAllowAttributeTypeChangeEnabled: isEnabled(
      FeatureToggle.AllowAttributeTypeChange
    ),
    isHomepageDashboardEnabled: isEnabled(FeatureToggle.HomepageDashboard),
    isSmartUploadTaskNotificationEnabled: isEnabled(
      FeatureToggle.SmartUploadTaskNotification
    ),
    isProductPageRefactorEnabled: isEnabled(FeatureToggle.ProductPageRefactor),
    isEnrichmentEmtpyAttributeEnabled: isEnabled(
      FeatureToggle.EnrichmentEmtpyAttribute
    ),
    isImporterParentInferEnabled: isEnabled(FeatureToggle.ImporterParentInfer),
    isPdpNavigationEnabled: isEnabled(FeatureToggle.PdpNavigation),
  };
}
